import styled from 'styled-components';

export const DetailsContainer = styled.div`
  margin: 10px 0 0 0;
  padding: 40px;
  width: inherit;

  * {
    box-sizing: border-box;
  }

  > * {
    margin: 0 0 10px 0;
  }
`;
